<template>
    <div class="table-wrapper inner">
        <md-table class="context-menu-support custom-paginated-table">
            <md-table-row class="table-header-row">
                <TableHeaderDropdown
                    column-icon="keyboard_arrow_down"
                    :default-text="selectedColumn.name"
                    :dropdown-options="columnDropdownOptions"
                    :selected-option="selectedColumn"
                    @selectedOption="handleSelectedColumn"
                />
                <md-table-head>Status</md-table-head>
                <md-table-head>Delivery Date</md-table-head>
                <md-table-head>Address</md-table-head>
                <md-table-head>Recipient</md-table-head>
            </md-table-row>

            <md-table-row v-for="order in orders" :key="order.orderId">
                <md-table-cell>
                    <router-link
                        v-if="selectedColumn.key == 'order-number'"
                        class="ref-link"
                        :to="{ name: 'Order Details', params: { orderId: order.orderId } }"
                        target="_blank"
                    >
                        {{ order.orderNumber }}
                    </router-link>
                    <router-link
                        v-else
                        class="ref-link"
                        :to="{ name: 'Order Details', params: { orderId: order.orderId } }"
                        target="_blank"
                    >
                        {{ order.sourceReference != null ? order.sourceReference : order.orderNumber }}
                    </router-link>
                </md-table-cell>
                <md-table-cell>
                    <span class="custom-badge" :class="`status-${$_getBadgeStatusColor(order.status)}`">
                        {{ order.status }}
                    </span>
                </md-table-cell>
                <md-table-cell>
                    {{ order.expectedDeliveryDate | dateFormat(DATE_TYPES.standardDate) }}
                </md-table-cell>
                <md-table-cell>
                    {{ order.shippingAddress.address }}
                </md-table-cell>
                <md-table-cell>
                    {{ order.contact.name }}
                </md-table-cell>
            </md-table-row>

            <md-table-row v-if="orders.length === 0">
                <md-table-cell colspan="5">
                    <p class="no-result-message">No results matching your search/filter could be found.</p>
                </md-table-cell>
            </md-table-row>
        </md-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { OrderMixin } from '@/mixins';
import { DATE_TYPES } from '@/utils/constants';
import { TableHeaderDropdown } from '@/components';
import moment from 'moment';

export default {
    name: 'SimplifiedOrderTable',
    mixins: [OrderMixin],
    components: {
        TableHeaderDropdown
    },
    props: {
        orders: {
            // Array of order objects
            type: Array,
            required: true
        },
        columnDropdownOptions: {
            type: Array,
            required: true
        },
        selectedColumn: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser'
        })
    },
    filters: {
        dateFormat(value, format) {
            if (!value) {
                return '';
            }
            return moment(value).format(format);
        }
    },
    data() {
        return {
            DATE_TYPES, // Expose DATE_TYPES to template
            isDisabled: false // Assuming this prop/data comes from parent if needed
        };
    },
    methods: {
        handleSelectedColumn(item) {
            this.$emit('column-selected', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.table-wrapper {
    // Add styles similar to the original table wrapper, but adjusted for the new column structure
    margin-left: 0; // Remove fixed left margin
}

/* Adjust column widths as needed */
.md-table-head,
.md-table-cell {
    // Remove fixed positioning and widths
    position: static;
    width: auto;
    // Add padding as needed
    padding: 12px 24px;
}

.action-buttons {
    ::v-deep .md-table-cell-container {
        width: auto; // Adjust width for action buttons
        text-align: right; // Align buttons to the right
    }
}

.custom-badge {
    background-color: #c2907f;
    max-width: initial !important;
    // Add padding and border-radius for badge styling
    padding: 4px 8px;
    border-radius: 4px;
    color: white; // Or a suitable text color
    font-size: 0.8em; // Adjust font size
}

.status-primary {
    background-color: #42a5f5; // Example color for primary status
}

.status-warning {
    background-color: #ffa726; // Example color for warning status
}

.status-info {
    background-color: #26a69a; // Example color for info status
}

// Add other status color classes as needed

.no-result-message {
    text-align: center;
    padding: 20px;
}
</style>
